export default __webpack_public_path__ + "static/media/zeta-chain.926ce225.svg";